import { useEffect, useState } from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReservesApi from '../../../../API/warehouse/reserves-api';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';
import { MAP_SKLAD, RESERVES_STATUS, RESERVES_STATUS_COLORS, TO_PRODUCT, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate, getDate } from '../../../../utils';
import AlertShip from './AlertShip';
import Dereserving from './DeReserving';
import styles from './styles.module.scss';
import { Content } from '../../../../components/Basic/Global';
import { H1, H2, Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { Column, ImagesViewer, Row } from '../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../components/Basic/Buttons';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../../components/Basic/Table';

export const width = ['80px', '110px', '270px', '90px', '90px', '180px', '10px', '10%', '130px', '180px'];

function ReservePage() {
  const match = useParams();
  const [alert, setAlert] = useState(false);
  const [info, setInfo] = useState({});
  const [byId, setById] = useState({});
  const [ids, setIds] = useState([]);

  const skladName = useSelector((store) => store.ui.skladName);

  const getReserve = () => {
    ReservesApi.getReserve({ data: { reserveId: match.id } }).then((r) => {
      setInfo(r.reserve);
      const byIds = {};
      const id = r.reservedProducts.map((item) => item._id);
      r.reservedProducts.forEach((item) => (byIds[item._id] = item));
      setById(byIds);
      setIds(id);
    });
  };

  const onShip = () => {
    ReservesApi.closeReserve({ data: { reserveId: info.id } }).then(() => {
      getReserve();
      setAlert(false);
    });
  };

  const onChangeItem = (id, status) => {
    ReservesApi.changeReservedProduct({ data: { reservedProductId: id, field: 'status', value: status } })
      .then(r => r.reservedProduct)
      .then(reservedProduct => {
        setById({ ...byId, [reservedProduct._id]: { ...byId[reservedProduct._id], ...reservedProduct } });
      });
  };

  useEffect(() => {
    getReserve();
  }, [match.id]);

  return (
    <Content>
      <H1>
        Резерв № {info.id} / {info.market} / {getDate(info.time_scheduled)} {MAP_SKLAD[info.skladName]}
      </H1>
      <Row style={{ marginBottom: '10px' }}>
        <H2>Статус: </H2>{' '}
        <div className={styles.status} style={{ color: `${RESERVES_STATUS_COLORS[info.status]}` }}>
          {`${RESERVES_STATUS[info.status] || ''}`}
        </div>
      </Row>
      <Column style={{ marginBottom: '10px' }}>
        <span>
          <TextGrey className={styles.grey_text}>Дата создания: </TextGrey>
          {info.date_create ? formFullDate(info.date_create) : `-`}
        </span>
        <span>
          <TextGrey className={styles.grey_text}>Создатель: </TextGrey>
          {info.creator}
        </span>

        <Row style={{ marginTop: '20px' }}>
          <Button type={TYPE_BUTTONS.GREEN} onClick={() => setAlert(true)} disabled={info.status === 'ended'}>
            Списать резервы
          </Button>

          <Button
            type={TYPE_BUTTONS.WHITE}
            onClick={() => ReservesApi.excelReserve({ data: { reserveId: info.id } })}
            style={{ marginLeft: '10px' }}
          >
            Скачать отчет
          </Button>
        </Row>
      </Column>

      <Table style={{ marginTop: '20px' }}>
        <TableHeader whiteHeader={true}>
          <HeaderTitle width={width[6]} />
          <HeaderTitle width={width[0]} />
          <HeaderTitle width={width[1]}>Артикул</HeaderTitle>
          <HeaderTitle width={width[0]} centerText>
            Адрес
          </HeaderTitle>
          <HeaderTitle width={width[2]}>Наименование</HeaderTitle>
          <HeaderTitle width={width[4]} centerText>
            Резерв
          </HeaderTitle>
          <HeaderTitle width={width[0]} centerText>
            Статус
          </HeaderTitle>

          <HeaderTitle width={width[5]} centerText>
            Дерезервировать
          </HeaderTitle>
          <HeaderTitle width={width[3]} centerText>
            На складе
          </HeaderTitle>
          <HeaderTitle width={width[2]}>Штрихкод</HeaderTitle>
          <HeaderTitle width={width[8]}>Время сборки резерва</HeaderTitle>
          <HeaderTitle width={width[9]}>Сборщик</HeaderTitle>
        </TableHeader>
        {ids.map((id, key) => {
          const item = byId[id];
          return (
            <TableLine key={item.id} styles={cn(item.is_assembled && styles.green_line)}>
              <TableCell width={width[6]}>{key + 1}</TableCell>
              <TableCell width={width[0]}>
                <ImagesViewer images={[item.image]} />
              </TableCell>
              <TableCell width={width[1]}>
                {item.warehouse_id}
                <TextGrey fontSize={12}>{formFullDate(item.date_create)}</TextGrey>
              </TableCell>
              <TableCell width={width[0]} center>
                {item.address}
              </TableCell>
              <TableCell width={width[2]}>
                <a href={TO_PRODUCT(item.warehouse_id)} target={'_blank'}>
                  {item.name}
                </a>
              </TableCell>
              <TableCell width={width[4]} center>
                <Text fontWeight={600}>{item.reserved}</Text>
                {item.dereserved > 0 && (
                  <Text style={{ color: 'red' }} fontWeight={500}>
                    {' '}
                    / ({-`${item.dereserved}`})
                  </Text>
                )}
              </TableCell>
              <TableCell width={width[0]} center>
                <CheckButton checked={item.is_assembled} onSelect={() => onChangeItem(item._id, !item.is_assembled)} />
              </TableCell>

              <TableCell width={width[5]} center>
                <Dereserving
                  id={item._id}
                  reserved={item.reserved}
                  readOnly={info.status === 'ended'}
                  get={getReserve}
                />
              </TableCell>
              <TableCell width={width[3]} center>
                {item.remains}
              </TableCell>
              <TableCell width={width[2]}>
                <BarcodesBlock barcodes={item.barcodes} readOnly={true} style={{ width: '250px' }} />
              </TableCell>
              <TableCell width={width[8]} center>
                {formFullDate(item.date_assembled)}
              </TableCell>
              <TableCell width={width[9]} center>
                {item.user_assembled}
              </TableCell>
            </TableLine>
          );
        })}
      </Table>

      <Row style={{ marginBottom: '20px' }}></Row>
      {alert && <AlertShip close={() => setAlert(false)} ship={onShip} />}
    </Content >
  );
}

export default ReservePage;
